<div class="table-scroll-wrapper">
            <table mat-table [dataSource]="dataSource" matSort class="report-table" fixedLayout="true">
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox 
                            (change)="$event ? masterToggle() : null" 
                            [checked]="isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()"
                            aria-label="Select all"
                        />
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox 
                            (click)="$event.stopPropagation()"
                            (change)="checkRow(row)" 
                            [checked]="selection.isSelected(row)"
                            [disabled]="row.status === 'Inactive'"
                            aria-label="Select row"
                        />
                    </td>
                </ng-container>

                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by title">Title
                    </th>
                    <td mat-cell *matCellDef="let report">
                        <a class="blue-link" [routerLink]="['edit', report.id]">{{ report.title }}</a>
                    </td>
                </ng-container>

                <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by code">Code</th>
                    <td mat-cell *matCellDef="let report">{{ report.code }}</td>
                </ng-container>

                <ng-container matColumnDef="nameEn">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name [EN]">Name
                        [EN]</th>
                    <td mat-cell *matCellDef="let report">{{ report.nameEn }}</td>
                </ng-container>

                <ng-container matColumnDef="nameRu">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name [RU]">Name
                        [RU]</th>
                    <td mat-cell *matCellDef="let report">{{ report.nameRu }}</td>
                </ng-container>

                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by type">Type</th>
                    <td mat-cell *matCellDef="let report">{{ report.type }}</td>
                </ng-container>

                <ng-container matColumnDef="createdOn">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by created on">
                        Created On</th>
                    <td mat-cell *matCellDef="let report">{{ report.createdOn | date: 'dd.MM.yyyy HH:mm' }}</td>
                </ng-container>

                <ng-container matColumnDef="createdBy">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by created by">
                        Created By</th>
                    <td mat-cell *matCellDef="let report">{{ report.createdBy | date: 'dd.MM.yyyy HH:mm' }}</td>
                </ng-container>

                <ng-container matColumnDef="mobifiedOn">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by modified on">
                        Modified On</th>
                    <td mat-cell *matCellDef="let report">{{ report.mobifiedOn | date: 'dd.MM.yyyy HH:mm' }}</td>
                </ng-container>

                <ng-container matColumnDef="modifiedBy">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by modified by">
                        Modified By</th>
                    <td mat-cell *matCellDef="let report">{{ report.modifiedBy | date: 'dd.MM.yyyy HH:mm' }}</td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by status">Status
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.status }}</td>
                </ng-container>

                <ng-container matColumnDef="statusReason">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by status reason">
                        Status Reason</th>
                    <td mat-cell *matCellDef="let report">{{ report.statusReason }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"
                    [class.selected]="selection.isSelected(row)" [class.disabled]="row.status === 'Inactive'"></tr>

            </table>
        </div>
        <mat-paginator 
            [pageSizeOptions]="pageSizeOptions"
            [length]="dataSource.data.length" 
            showFirstLastButtons
        ></mat-paginator>